/**
 * useRiderWorkStatus Hook (파사드)
 * 라이더 근무 현황 페이지의 데이터 및 상태 관리 훅
 *
 * @description
 * - useWorkStatusFilters: 필터 상태 관리
 * - useWorkStatusData: 데이터 조회 (API 호출, 응답 매핑)
 * - useExcelDownload: 엑셀 다운로드
 *
 * @returns 근무 현황 데이터 상태 및 관리 함수
 */
import { useEffect, useCallback } from 'react';
import { getItem } from '@/shared/utils/storage';
import { useWorkStatusFilters, createDefaultFilters } from "@/features/settlement/riderWorkStatus/hooks/useWorkStatusFilters";
import { useWorkStatusData } from "@/features/settlement/riderWorkStatus/hooks/useWorkStatusData";
import { useExcelDownload } from "@/features/settlement/riderWorkStatus/hooks/useExcelDownload";

export const useRiderWorkStatus = () => {
    const userId = getItem<string>('USER_ID');
    const { filters, isSupplierUser, handleFilterChange } = useWorkStatusFilters();
    const { loading, workStatusData, fetchWorkStatus } = useWorkStatusData(isSupplierUser, userId);
    const { excelDownloading, handleExcelDownload: downloadExcel } = useExcelDownload(isSupplierUser, userId);

    /**
     * 검색 실행
     */
    const handleSearch = useCallback(() => {
        fetchWorkStatus(filters);
    }, [fetchWorkStatus, filters]);

    /**
     * 엑셀 다운로드 (현재 필터 기준)
     */
    const handleExcelDownload = useCallback(() => {
        return downloadExcel(filters);
    }, [downloadExcel, filters]);

    /**
     * 초기 데이터 로드
     */
    useEffect(() => {
        const initialFilters = createDefaultFilters();
        fetchWorkStatus(initialFilters);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        loading,
        excelDownloading,
        workStatusData,
        filters,
        isSupplierUser,
        handleFilterChange,
        handleSearch,
        handleExcelDownload,
        fetchWorkStatus,
    };
};
